import {ReactElement} from 'react'
import Modal from '@material-ui/core/Modal'

import {useStyles} from './styles'

function ModalContainer({children, isOpen, onClose}): ReactElement {
  const classes = useStyles()

  return (
    <Modal className={classes.modal} open={isOpen} onClose={onClose}>
      {children}
    </Modal>
  )
}

export {ModalContainer}
